<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Card number change'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="numberForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'New card number'|translate}}</mat-label>
                    <input name="number" formControlName="number" matInput required (input)="verifyCardNumber($event)">
                    <mat-icon matSuffix class="secondary-text" *ngIf="!checkingCardNumber">credit_card</mat-icon>
                    <mat-icon matSuffix class="secondary-text" *ngIf="checkingCardNumber">sync</mat-icon>
                </mat-form-field>
            </div>
            <div class="row" style="color: red;" *ngIf="cardExists && cardNumber.length>0 && !checkingCardNumber">{{'Card number already exists!'|translate}}</div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                [disabled]="cardExists || cardNumber.length === 0"
                (click)="matDialogRef.close(numberForm)"
                aria-label="Save">
            {{'Save'|translate}}
        </button>

    </div>
</div>
